/**!
 *  Edit an existing skill-building activity.
 */

import React, {useState} from 'react'
import styles from './skillBuilding.module.scss'

import API from 'Class/API'

import Button from 'Components/UI/Button'
import Edit from './edit'

const TabEdit = ({community, item, loading, message, onCancel, onClose, onSave}) =>
{
    const [hasChanged, setHasChanged] = useState(false)
    const [data, setData] = useState({})
    const [exporting, setExporting] = useState(false)
    const [exportNotice, setExportNotice] = useState(false)
    const [input, setInput] = useState(item)
    const [ready, setReady] = useState(false)

    const onData = (data, hasChanged) =>
    {
        setHasChanged(hasChanged)
        setData(data)
    }

    const onExport = async () =>
    {
        setExporting(true)
        setExportNotice('Exporting...')
        const {url} = await API.RequestAsync('skillActivities/export', {activity: item?.id})
        setExporting(false)
        if (!url)
        {
            setExportNotice('Failed to export activity')
            return
        }
        setExportNotice(<>Export should open automatically. If not <a target='_blank' href={url}>click here</a></>)

        const link = document.createElement('a')
        link.href = url
        link.target = '_blank'
        
        link.click()
    }

    const onSaveData = async (data) =>
    {
        const saved = await onSave(data)
        if (!saved)
        {
            return
        }
        setInput(data)
        setHasChanged(false)
    }

    return (
        <>
            <div className={styles.tab}>
                <h2>Edit technical skill</h2>
                <Edit
                    community={community}
                    data={input}
                    key={item?.id}
                    onChange={onData}
                    onReadyState={setReady}
                />
            </div>
            <div className={styles.tray}>
                <Button
                    disabled={!hasChanged || !ready || loading}
                    label='Save'
                    loading={loading}
                    onClick={() => onSaveData(data)}
                />
                <Button
                    disabled={exporting}
                    hollow={true}
                    label='Export users'
                    loading={exporting}
                    onClick={onExport}
                />
                <Button
                    hollow={true}
                    label={hasChanged ? 'Cancel' : 'Back'}
                    onClick={onCancel}
                />
                <Button
                    hollow={true}
                    label='Close'
                    onClick={onClose}
                />
                {exportNotice && <div className={styles.message}>{exportNotice}</div>}
                {!exportNotice && message && <div className={styles.message}>{message}</div>}
            </div>
        </>
    )
}

export default TabEdit